// Size charts for fit 5.0 // //Floor, midi, ankle, tea, mini, see assets/product--size-chart-scripts.js.liquid,
const refitFloor = [
  {
    data: [
      "Numeric Sizing",
      "Bust range",
      "Waist range",
      "Hiprange",
      "Dress Length",
    ],
  },
  { data: ["XS", "0-2", "32-34", "26-28", "35-37", "61.5"] },
  { data: ["S", "4-6", "34-36", "28-30", "37-39", "62"] },
  { data: ["M", "8-10", "36-38", "30-32", "39-41", "62.5"] },
  { data: ["L", "12", "38-40.5", "32-34", "41-43", "63"] },
  { data: ["XL", "14", "41-43", "34-36", "43-45", "63"] },
  { data: ["XXL", "16", "43-45", "36-38", "45-47", "63"] },
  { data: ["1X", "18", "45-47", "39-41", "47-49", "63"] },
  { data: ["2X", "20", "47-49", "42-44", "49-51", "63"] },
  { data: ["3X", "22", "49-51", "45-47", "51-53", "63"] },
];

const refitMidi = [
  {
    data: [
      "Numeric Sizing",
      "Bust range",
      "Waist range",
      "Hip range",
      "Dress Length",
    ],
  },
  { data: ["XS", "0-2", "32-34", "26-28", "35-37", "47.5"] },
  { data: ["S", "4-6", "34-36", "28-30", "37-39", "48"] },
  { data: ["M", "8-10", "36-38", "30-32", "39-41", "48.5"] },
  { data: ["L", "12", "38-40.5", "32-34", "41-43", "49"] },
  { data: ["XL", "14", "41-43", "34-36", "43-45", "49"] },
  { data: ["XXL", "16", "43-45", "36-38", "45-47", "49"] },
  { data: ["1X", "18", "45-47", "39-41", "47-49", "49"] },
  { data: ["2X", "20", "47-49", "42-44", "49-51", "49"] },
  { data: ["3X", "22", "49-51", "45-47", "51-53", "49"] },
];

const refitAnkle = [
  {
    data: [
      "Numeric Sizing",
      "Bust range",
      "Waist range",
      "Hip range",
      "Dress Length",
    ],
  },
  { data: ["XS", "0-2", "32-34", "26-28", "35-37", "57.5"] },
  { data: ["S", "4-6", "34-36", "28-30", "37-39", "58"] },
  { data: ["M", "8-10", "36-38", "30-32", "39-41", "58.5"] },
  { data: ["L", "12", "38-40.5", "32-34", "41-43", "59"] },
  { data: ["XL", "14", "41-43", "34-36", "43-45", "59"] },
  { data: ["XXL", "16", "43-45", "36-38", "45-47", "59"] },
  { data: ["1X", "18", "45-47", "39-41", "47-49", "59"] },
  { data: ["2X", "20", "47-49", "42-44", "49-51", "59"] },
  { data: ["3X", "22", "49-51", "45-47", "51-53", "59"] },
];

const refitTea = [
  {
    data: [
      "Numeric Sizing",
      "Bust range",
      "Waist range",
      "Hip range",
      "Dress Length",
    ],
  },
  { data: ["XS", "0-2", "32-34", "26-28", "35-37", "53.5"] },
  { data: ["S", "4-6", "34-36", "28-30", "37-39", "54"] },
  { data: ["M", "8-10", "36-38", "30-32", "39-41", "54.5"] },
  { data: ["L", "12", "38-40.5", "32-34", "41-43", "55"] },
  { data: ["XL", "14", "41-43", "34-36", "43-45", "55"] },
  { data: ["XXL", "16", "43-45", "36-38", "45-47", "55"] },
  { data: ["1X", "18", "45-47", "39-41", "47-49", "55"] },
  { data: ["2X", "20", "47-49", "42-44", "49-51", "55"] },
  { data: ["3X", "22", "49-51", "45-47", "51-53", "55"] },
];

const refitMini = [
  {
    data: [
      "Numeric Sizing",
      "Bust range",
      "Waist range",
      "Hip range",
      "Dress Length",
    ],
  },
  { data: ["XS", "0-2", "32-34", "26-28", "35-37", "33.5"] },
  { data: ["S", "4-6", "34-36", "28-30", "37-39", "34"] },
  { data: ["M", "8-10", "36-38", "30-32", "39-41", "34.5"] },
  { data: ["L", "12", "38-40.5", "32-34", "41-43", "35"] },
  { data: ["XL", "14", "41-43", "34-36", "43-45", "35"] },
  { data: ["XXL", "16", "43-45", "36-38", "45-47", "35"] },
  { data: ["1X", "18", "45-47", "39-41", "47-49", "38"] },
  { data: ["2X", "20", "47-49", "42-44", "49-51", "38"] },
  { data: ["3X", "22", "49-51", "45-47", "51-53", "38"] },
];
